class EditSellingCardReq{
    constructor()
    {
        this.id = null;
        this.name = null;
        this.description = null;
        this.salesOrgId = null;
    }
}
export default EditSellingCardReq